import { createApiRef } from "@backstage/core-plugin-api";

export interface ContainerScansPluginApi {
    getHealth(): Promise<string>;
    getContainerScans(
        page?: number,
        pageSize?: number,
        sortBy?: string,
        sortOrder?: "asc" | "desc",
        q?: string,
    ): Promise<ContainerScansResponse>;
    getContainerScansCsv(): Promise<Response>;
    getContainerScansSummary(): Promise<Response>;
}

export const containerScansPluginApiRef = createApiRef<ContainerScansPluginApi>({
  id: "plugin.container-scans-ui.service",
});

export type Severity = "Critical" | "High" | "Medium" | "Low" | "Informational" | "Undefined"

export type FindingRow = {
    accountId: string;
    accountName: string;
    region: string;
    repository: string;
    imageTag: string;
    imageDigest: string;
    pushedAt: string;
    lastPulledAt: string;
    findingName: string;
    severity: Severity;
    package: string;
    uri: string;
    projects: string;
    stackNames: string;
    description: string;
};

export type ContainerScansResponse = {
    items: FindingRow[];
    totalCount: number;
};

export type UsedByProject = {
    projectName: string;
};

export type UsedByCfnStacks = {
    stackName: string;
};